import { render } from "./paymentStatus.vue?vue&type=template&id=15d6f3c2"
import script from "./paymentStatus.vue?vue&type=script&lang=js"
export * from "./paymentStatus.vue?vue&type=script&lang=js"

import "./paymentStatus.vue?vue&type=style&index=0&id=15d6f3c2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__